import "./GalleryTab.css";
import getImageUrl from "../../../../utils/imageUrl";

function GalleryTab({ food }) {

    const images = [];

    if (food.image) {
        images.push(food.image);
    }

    if (food.images && Array.isArray(food.images)) {
        images.push(...food.images);
    }

    return (

        <div className="gallery-tab">

            <h2>Food Gallery</h2>

            {images.length === 0 ? (

                <div className="gallery-empty">

                    <h3>No Images Available</h3>

                    <p>
                        This food doesn't have any uploaded images.
                    </p>

                </div>

            ) : (

                <div className="gallery-grid">

                    {images.map((image, index) => {

                        const imageUrl =
                            getImageUrl(image);

                        return (

                            <div
                                className="gallery-card"
                                key={index}
                            >

                                <img
                                    src={imageUrl}
                                    alt={`Food ${index + 1}`}
                                    onError={(event) => {
                                        event.currentTarget.src =
                                            "/images/food-placeholder.png";
                                    }}
                                />

                            </div>

                        );

                    })}

                </div>

            )}

        </div>

    );

}

export default GalleryTab;